import { FC } from 'react';
import { GetImage } from 'ts/package/interfaces/PackageOfflineResponse';
import Slider from 'react-slick';
import withErrorBoundary from 'components/shared/withErrorBoundary';

interface HotelGalleryProps {
  images: GetImage[];
}

const HotelGallery: FC<HotelGalleryProps> = ({ images }) => {
  return (
    <div className="details-slider-images">
      <Slider arrows={true} dots>
        {images.map((image, index) => (
          <div key={index} className="slider-main-image">
            <div className="slider-main-image-title">{image.desc}</div>
            <img src={image.imageLink} alt={image.imageAlt} />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default withErrorBoundary(HotelGallery, 'HotelGallery');
